(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/onboarding-handler/prescript.js') >= 0) return;  svs.modules.push('/components/accountservices/onboarding-handler/prescript.js');
'use strict';

svs.accountservices = svs.accountservices || {};
svs.accountservices.onboardingHandler = svs.accountservices.onboardingHandler || {};


 })(window);